import React from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import * as ROUTES from '../../constants/routes';
import {AuthUserContext, UserContext, CompanyViewContext, BranchViewContext, EmployeeDataViewContext,SessionDomainContext,DomainExpirationStatusContext,FeatureStatusContext} from './context';
import { withFirebase } from '../Firebase';

const withAuthDomain = (condition=()=>true,routefail=ROUTES.LANDING,mainDomain="",featureDomain="") => Component => {
    class WithAuthDomain extends React.Component {

        constructor(props) {
            super(props);
            this.state = {
                authUser:null,

                currentUser:null,
                domainView:"",
                companyView:null,
                branchView:null,
                employeeData:null,

                //domainSubscribingData:null,
                domainExpirationStatus:-1,//-1=notDone|readOnly,0=expired|hidden,1=active
                featureStatus:-1,//-1=notDone|hidden,0=disabled|hidden,1=enabled
                
                rejected: null,
                errorPosition:"",
            };
        }

        componentDidMount() {
            
            this.listener = this.props.firebase.auth.onAuthStateChanged(
                authUser => {
                    if (!condition(authUser)) {
                        if (routefail){//if param=false => skip all redirect
                            this.props.history.push(routefail)
                        }
                    }else{
                        //accepted enter page
                        this.setState({authUser:authUser})
                        if(!!this.listenerUserObject ) {this.listenerUserObject()}
                        if(!!this.listenerCompanyObject ) {this.listenerCompanyObject()}
                        if(!!this.listenerBranchObject ) {this.listenerBranchObject()}
                        if(!!this.listenerEmployeeDataObject ) {this.listenerEmployeeDataObject()}
                        if(!!this.listenerCompanyDomainSubscribtionObject){this.listenerCompanyDomainSubscribtionObject()}
                        if(!!this.listenerFeatureConfigObject ) {this.listenerFeatureConfigObject()}

                        if(!authUser){
                            this.setState({

                                currentUser:null,
                                domainView:"",
                                companyView:null,
                                branchView:null,
                                employeeData:null,
                                domainExpirationStatus:-1,
                                featureStatus:-1,
                                
                            })
                            return
                        }
                        
                        this.listenerUserObject= this.props.firebase.fs.doc("users/"+authUser.uid).onSnapshot((userDoc) => {
                        
                            if (userDoc.exists) {
                              
                              this.setState({
                                currentUser:userDoc.data(),
                              })

                              if(mainDomain===""||userDoc.data().domainView===mainDomain){
                                //sudah benar
                                this.setState({
                                  domainView:mainDomain,
                                })

                                //simultaneous 1 check companyViewId
                                if(!!userDoc.data().companyViewId){
                                  //sudah memilih companyViewId
                                  if(!!this.state.companyView&&this.state.companyView.id===userDoc.data().companyViewId){
                                    //masih pada companyViewId yang sama, skip
                                    
                                  }else{
                                    //companyViewId berubah, init new company object, reset branch object + employeeData object + user
                                    if(!!this.listenerCompanyObject ) {this.listenerCompanyObject()}
                                    if(!!this.listenerBranchObject ) {this.listenerBranchObject()}
                                    if(!!this.listenerEmployeeDataObject ) {this.listenerEmployeeDataObject()}
                                    if(!!this.listenerCompanyDomainSubscribtionObject){this.listenerCompanyDomainSubscribtionObject()}
                                    if(!!this.listenerFeatureConfigObject ) {this.listenerFeatureConfigObject()}
                                    //simultaneous 1.1
                                    this.listenerCompanyObject= this.props.firebase.fs.doc("companies/"+userDoc.data().companyViewId).onSnapshot((companyDoc) => {
                                      if (companyDoc.exists) {
                                        if(typeof(Storage)!=="undefined"){
                                          window.localStorage.setItem("companyViewId",companyDoc.data().id)
                                          window.localStorage.setItem("companyViewName",companyDoc.data().name)
                                        }
                                        this.setState({
                                          companyView:companyDoc.data(),
                                          branchView:null,
                                          employeeData:null,
                                        })
                                      }else{
                                        this.setState({
                                          companyView:null,
                                          branchView:null,
                                          employeeData:null,
                                        })
                                      }
                                    },(e)=>{
                                      this.setState({
                                        companyView:null,
                                        branchView:null,
                                        employeeData:null,
                                      })
                                      this.setState({rejected:e,errorPosition:"listenerCompanyObject"})
                                    })

                                    //simultaneous 1.2 check company subscription data
                                    //console.log("check company subscription data")
                                    //if(!!this.listenerCompanyDomainSubscribtionObject){this.listenerCompanyDomainSubscribtionObject()}
                                    if(!!mainDomain){
                                      this.listenerCompanyDomainSubscribtionObject= this.props.firebase.fs.doc("domains/"+mainDomain+"/domainSubscribers/"+userDoc.data().companyViewId).onSnapshot((companySubscribtionDoc) => {
                                        //console.log("on check company subscription data")
                                        if (companySubscribtionDoc.exists) {
                                          //console.log("companySubscribtionDoc.exists getServerTime...")
                                          if(companySubscribtionDoc.data().enabled){
                                            var getServerTime = this.props.firebase.fn.httpsCallable('getServerTime')
                                            getServerTime().then((result)=>{
                                              if(result.data>=companySubscribtionDoc.data().expiration){
                                                //expired
                                                //console.log("expired")
                                                this.setState({
                                                  domainExpirationStatus:0,
                                                })
                                              }else{
                                                //company subscribing active
                                                //console.log("company subscribing active")
                                                this.setState({
                                                  domainExpirationStatus:1,
                                                })
                                              }
                                            }).catch(e=>{
                                              //console.log("error 2 "+e)
                                              this.setState({
                                                domainExpirationStatus:0,
                                              })
                                              this.setState({rejected:e,errorPosition:"listenerCompanyDomainSubscribtionObject getServerTime"})
                                            })
                                          }else{
                                            console.log("company subscribing disabled")
                                            //company subscribing not found/expired=hidden
                                            this.setState({
                                              domainExpirationStatus:0,
                                            })
                                          }
                                        }else{
                                          console.log("company subscribing not found")
                                          //company subscribing not found/expired=hidden
                                          this.setState({
                                            domainExpirationStatus:0,
                                          })
                                        }
                                      },(e)=>{
                                        console.log("error 1 "+e)
                                        this.setState({
                                          domainExpirationStatus:0,
                                        })
                                        this.setState({rejected:e,errorPosition:"listenerCompanyDomainSubscribtionObject"})
                                      })
                                    }
                                  }

                                }else{
                                  //belum pernah memilih companyViewId, reset company object, reset branch object + employeeData object + domainExpirationStatus + featureConfig object
                                  if(!!this.listenerCompanyObject ) {this.listenerCompanyObject()}
                                  if(!!this.listenerBranchObject ) {this.listenerBranchObject()}
                                  if(!!this.listenerEmployeeDataObject ) {this.listenerEmployeeDataObject()}
                                  if(!!this.listenerCompanyDomainSubscribtionObject){this.listenerCompanyDomainSubscribtionObject()}
                                  if(!!this.listenerFeatureConfigObject ) {this.listenerFeatureConfigObject()}
                                  this.setState({
                                    companyView:null,
                                    branchView:null,
                                    employeeData:null,
                                    domainExpirationStatus:-1,
                                    featureStatus:-1,
                                  })
                                }


                                //simultaneous 2 check branchView
                                if(!!userDoc.data().companyViewId&&!!userDoc.data().branchViewId){
                                  //sudah memilih branchViewId
                                  if(this.state.branchView&&this.state.branchView.id===userDoc.data().branchViewId){
                                    //masih pada branchViewId yang sama, skip
                                  }else{
                                    //branchView berubah, init new listener branch object + init new listener employeeData object + init new listener featureConfig object
                                    //init listener new branch object
                                    if(!!this.listenerBranchObject ) {this.listenerBranchObject()}
                                    this.listenerBranchObject= this.props.firebase.fs.doc("companies/"+userDoc.data().companyViewId+"/branches/"+userDoc.data().branchViewId).onSnapshot((branchDoc) => {
                                      if (branchDoc.exists) {
                                        if(typeof(Storage)!=="undefined"){
                                          window.localStorage.setItem("branchViewId",branchDoc.data().id)
                                          window.localStorage.setItem("branchViewName",branchDoc.data().name)
                                        }
                                        this.setState({
                                          branchView:branchDoc.data(),
                                        })
                                      }else{
                                        this.setState({
                                          branchView:null,
                                        })
                                      }
                                    },(e)=>{
                                      this.setState({
                                        branchView:null,
                                      })
                                      this.setState({rejected:e,errorPosition:"listenerBranchObject"})
                                    })
                                    //init new listener employeeData object
                                    if(!!this.listenerEmployeeDataObject ) {this.listenerEmployeeDataObject()}
                                    this.listenerEmployeeDataObject= this.props.firebase.fs.doc("companies/"+userDoc.data().companyViewId+"/branches/"+userDoc.data().branchViewId+"/employeeData/"+authUser.uid).onSnapshot((employeeDataDoc) => {
                                      if(employeeDataDoc.exists){
                                        this.setState({
                                          employeeData:employeeDataDoc.data(),
                                        })
                                      }else{
                                        this.setState({
                                          employeeData:null,
                                        })
                                      }
                                    },(e)=>{
                                      this.setState({
                                        employeeData:null,
                                      })
                                      this.setState({rejected:e,errorPosition:"listenerEmployeeDataObject"})
                                    })
                                    //init new listener featureConfig object
                                    if(!!mainDomain&&!!featureDomain){
                                      if(!!this.listenerFeatureConfigObject ) {this.listenerFeatureConfigObject()}
                                      //this.listenerFeatureConfigObject= this.props.firebase.fs.doc("companies/"+userDoc.data().companyViewId+"/branches/"+userDoc.data().branchViewId+"/features/"+featureName).onSnapshot((featureConfigDoc) => {
                                      this.listenerFeatureConfigObject= this.props.firebase.fs.doc("domains/"+mainDomain+"/domainSubscribers/"+userDoc.data().companyViewId+"/branchSubscribers/"+userDoc.data().branchViewId).onSnapshot((branchFeatures) => {
                                        if (branchFeatures.exists) {
                                          this.setState({
                                            featureStatus:branchFeatures.data().enabled&&!!branchFeatures.data().features&&branchFeatures.data().features.includes(featureDomain)?1:0,
                                          })
                                        }else{
                                          this.setState({
                                            featureStatus:0,
                                          })
                                        }
                                      },(e)=>{
                                        this.setState({
                                          featureStatus:0,
                                        })
                                        this.setState({rejected:e,errorPosition:"listenerFeatureConfigObject"})
                                      })
                                    }
                                  }
                                }else{
                                  //belum pernah memilih branchView, reset branch object + employeeData object + featureConfig object
                                  if(!!this.listenerBranchObject ) {this.listenerBranchObject()}
                                  if(!!this.listenerEmployeeDataObject ) {this.listenerEmployeeDataObject()}
                                  if(!!this.listenerFeatureConfigObject ) {this.listenerFeatureConfigObject()}
                                  this.setState({
                                    branchView:null,
                                    employeeData:null,
                                    featureStatus:-1,
                                  })
                                }
                                
                              }else{
                                //set domain view to domain, clear companyViewId dan BranchView
                                if(!!this.listenerCompanyObject ) {this.listenerCompanyObject()}
                                if(!!this.listenerBranchObject ) {this.listenerBranchObject()}
                                if(!!this.listenerEmployeeDataObject ) {this.listenerEmployeeDataObject()}
                                if(!!this.listenerCompanyDomainSubscribtionObject){this.listenerCompanyDomainSubscribtionObject()}
                                if(!!this.listenerFeatureConfigObject ) {this.listenerFeatureConfigObject()}
                                this.props.firebase.doSignOut()
                                this.setState({
                                  domainView:mainDomain,
                                  companyView:null,
                                  branchView:null,
                                  employeeData:null,
                                  domainExpirationStatus:-1,
                                  featureStatus:-1,
                                })
                                /*this.props.firebase.fs.doc("users/"+authUser.uid).set({domainView:"",companyViewId:"",branchViewId:""},{merge:true})
                                .then(()=>{
                                  this.setState({
                                    domainView:"",
                                    companyView:null,
                                    branchView:null,
                                    employeeData:null,
                                    domainExpirationStatus:-1,
                                    featureStatus:-1,
                                  })
                                  this.props.firebase.doSignOut()
                                }).catch((e)=>{
                                  this.setState({rejected:e,errorPosition:"cannot set new domainView and clear companyViewId + branchViewId"})
                                })*/
                              }
                              

                            }else{
                              if(!!this.listenerCompanyObject ) {this.listenerCompanyObject()}
                              if(!!this.listenerBranchObject ) {this.listenerBranchObject()}
                              if(!!this.listenerEmployeeDataObject ) {this.listenerEmployeeDataObject()}
                              if(!!this.listenerCompanyDomainSubscribtionObject){this.listenerCompanyDomainSubscribtionObject()}
                              if(!!this.listenerFeatureConfigObject ) {this.listenerFeatureConfigObject()}

                              //new account here
                              this.setState({
                                currentUser:null,
                                domainView:"",
                                companyView:null,
                                branchView:null,
                                employeeData:null,
                                domainExpirationStatus:-1,
                                featureStatus:-1,
                              })
                            }
                        },(e)=>{
                            this.setState({rejected:e,errorPosition:"listenerUserObject"})
                        })

                        
                    }
                },
            );
            
        }


        componentWillUnmount() {
            this.listener();
            if(!!this.listenerUserObject ) {this.listenerUserObject()}
            if(!!this.listenerCompanyObject ) {this.listenerCompanyObject()}
            if(!!this.listenerBranchObject ) {this.listenerBranchObject()}
            if(!!this.listenerEmployeeDataObject ) {this.listenerEmployeeDataObject()}
            if(!!this.listenerCompanyDomainSubscribtionObject){this.listenerCompanyDomainSubscribtionObject()}
            if(!!this.listenerFeatureConfigObject ) {this.listenerFeatureConfigObject()}
        }
  
        render() {
          var sessionDomain=0
          if(!this.state.authUser&&!this.state.currentUser&&!this.state.companyView&&!this.state.branchView&&!this.state.employeeData){
            sessionDomain=0
            //this.setState({
            //  sessionDomain:0,//no-login-anonymous
            //})
          }else if(!!this.state.authUser&&!this.state.currentUser&&!this.state.companyView&&!this.state.branchView&&!this.state.employeeData){
            //new account here
            sessionDomain=0
            //this.setState({
            //  sessionDomain:0,//login-new account on progress
            //})
          }else if(!!this.state.authUser&& !!this.state.currentUser&&!this.state.companyView&&!this.state.branchView&&!this.state.employeeData){
            sessionDomain=1
            //this.setState({
            //  sessionDomain:1,//login-guess
            //})
          }else if(!!this.state.authUser&& !!this.state.currentUser&&!!this.state.companyView&&!this.state.branchView&&!this.state.employeeData){
            sessionDomain=2
            //this.setState({
            //  sessionDomain:2,//login-company
            //})
          }else if(!!this.state.authUser&& !!this.state.currentUser&&!!this.state.companyView&&!!this.state.branchView&&!this.state.employeeData){
            sessionDomain=3
            //this.setState({
            //  sessionDomain:3,//login-branch-customer
            //})
          }else if(!!this.state.authUser&& !!this.state.currentUser&&!!this.state.companyView&&!!this.state.branchView&&!!this.state.employeeData){
            sessionDomain=4
            //this.setState({
            //  sessionDomain:4,//login-admin/employee
            //})
          }else{
            sessionDomain=-1
            //this.setState({
            //  sessionDomain:-1,//error
            //})
          }

          if(mainDomain===""){
            //landing page
          }else if(featureDomain===""){
            //home page
            if(this.state.domainExpirationStatus===0){
              this.props.history.push(ROUTES.LANDING)
            }
          }else if(featureDomain!==""){
            //featured page
            if(this.state.domainExpirationStatus===0||this.state.featureStatus===0){
              return <>503 Service Unavailable</>
            }else if(this.state.featureStatus===-1){
              if(!!routefail){
                return "Preparing..."
              }
            }
          }
          return (
            <AuthUserContext.Consumer>
            {(authUser) =>{
                return condition(authUser) ?
                    <UserContext.Provider value={this.state.currentUser}>
                        <CompanyViewContext.Provider value={this.state.currentCompany}>
                            <BranchViewContext.Provider value={this.state.currentBranch}>
                                <EmployeeDataViewContext.Provider value={this.state.accesses}>
                                  <SessionDomainContext.Provider value={sessionDomain}>
                                    <DomainExpirationStatusContext.Provider value={this.state.domainExpirationStatus}>
                                      <FeatureStatusContext.Provider value={this.state.featureStatus}>
                                        <Component
                                          authUser={authUser}

                                          currentUser={this.state.currentUser}
                                          //domainView={this.state.domainView}
                                          companyView={this.state.companyView}
                                          branchView={this.state.branchView}
                                          employeeData={this.state.employeeData}

                                          sessionDomain={sessionDomain}

                                          domainExpirationStatus={this.state.domainExpirationStatus}

                                          featureStatus={this.state.featureStatus}

                                          rejected={this.state.rejected}
                                          errorPosition={this.state.errorPosition}
                                          {...this.props}
                                        />
                                      </FeatureStatusContext.Provider>
                                    </DomainExpirationStatusContext.Provider>
                                  </SessionDomainContext.Provider>
                                </EmployeeDataViewContext.Provider>
                            </BranchViewContext.Provider>
                        </CompanyViewContext.Provider>
                    </UserContext.Provider>
                :
                  routefail?
                    <div>Securing connection...</div>
                  :
                    <div>Preview Not Available<br /><span>You dont have any access</span></div>
                }
            }
            </AuthUserContext.Consumer>
          )
        }
    }

    return compose(
        withRouter,
        withFirebase,
    )(WithAuthDomain);
};

export default withAuthDomain;